const initialState = {
  sidePanelPopOver: {
    visible: false
  }
}

export default function (state=initialState, { type, payload }) {
  switch(type){
    case "UPDATE_UI":
      return {
        ...state,
        ...payload
      }
    default: 
      return state
  }
}